import styled from "styled-components";

export const Container = styled.div``;

export const ContainerVideo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
